<template>
  <div :class="{'swiper-slide': class_swiper_slide}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SwiperSlide',
  props: {
    class_swiper_slide: {
      type: Boolean,
      default: true
    }
  }
}
</script>
